import Swiper from "swiper";
import {createSwiper} from "../utils/swiper";

export const StepsSlider = {
	swiper: null as Swiper | null,

	init(): void {
		this.swiper = createSwiper('.wv-steps-slider', 'wv-step', {
			autoplay: {
				delay: 1500,
				disableOnInteraction: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1.5,
					spaceBetween: 8,
				},
				480: {
					slidesPerView: 2,
					spaceBetween: 12
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 20,
				}
			},
			centeredSlides: false,
			direction: "horizontal",
			loop: false,
			mousewheel: true
		});
	},

};
